import { onError } from '@apollo/client/link/error';
import { log } from '../utils/errorHandler';

export default onError(({ networkError, graphQLErrors }) => {
  graphQLErrors?.forEach(({ message, locations, path }) => {
    log(
      `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
        locations,
      )}, Path: ${path}`,
    );
  });
  if (networkError) log(`[Network error]: ${networkError.message}`);
});
